import { useCallback } from 'react';

import { buildExploreExternalPrefillNavigateState } from '@/features/explore/explore-navigation-entry';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';

export const useExploreAdvancedNavigation = (): ((
  problemDescription: string,
) => void) => {
  const navigateTo = useNavigateTo();

  return useCallback(
    (problemDescription: string): void => {
      const trimmed = problemDescription.trim();

      if (!trimmed.length) {
        navigateTo.explore();
        return;
      }

      navigateTo.explore(undefined, undefined, {
        state: buildExploreExternalPrefillNavigateState({
          description: trimmed,
        }),
      });
    },
    [navigateTo],
  );
};
